import { Component } from 'preact';

export default class RegularVideo extends Component {

		playVideo = (e) =>{

			//only play if first time around, this allows thumnail to trigger play
			if (this.state.playedOnce === false){
				 e.target.play()
				 this.setState({playedOnce: true})
			}

		}

		constructor(props) {
			super(props);
			this.state = { playedOnce: false};
		}

		render(){
		let {data} = this.props
		//make 12 if no data default to xs. if no xs then it will be 12
		let xs = data && data.xs ? data.xs : '12'
		let sm = data && data.sm ? data.sm : xs
		let md = data && data.md ? data.md : sm
		let lg = data && data.lg ? data.lg : md
		let className= 'col-xs-'+ xs + ' col-sm-'+ sm + ' col-md-'+ md + ' col-lg-'+ lg + ' '

		let fixedHeight = this.props.fixedHeight ? this.props.fixedHeight : null

		if (fixedHeight){

			return (
				<div id={data.richId} className={className} style={{padding: '10px', position: 'relative', height: fixedHeight + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
					<video onClick={this.playVideo}  style={{ cursor: 'pointer', maxHeight: '100%', maxWidth: '100%'}} controls  key={data.richId} poster={data.posterSrc}>
						<source src={data.vidSrc} type="video/mp4" />
						Your browser does not support HTML5 video.
					</video>
				</div>
			)
		}

		return(
				<div id={data.richId} className={className} style={{padding: '10px', position: 'relative'}} >
					<video onClick={this.playVideo}  style={{width: '100%', cursor: 'pointer'}} controls  key={data.richId} poster={data.posterSrc}>
						<source src={data.vidSrc} type="video/mp4" />
						Your browser does not support HTML5 video.
					</video>
				</div>
    )

	}


}



// WEBPACK FOOTER //
// ./components/contentTypes/video/regularVideo.js